module.exports = __webpack_public_path__ + "static/media/blindcode.a8605c65.jpeg";